"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCloudUpload(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 11.17h.03a.77.77 0 01.048.004l-.077-.004a.771.771 0 01.468.16l.073.065 3.064 3.063a.766.766 0 01-.997 1.158l-.086-.074-1.757-1.757v7.343a.766.766 0 01-1.524.104l-.007-.104-.001-7.343-1.756 1.757a.766.766 0 01-.997.074l-.086-.074a.766.766 0 01-.074-.998l.074-.086 3.064-3.063.073-.065a.772.772 0 01.007-.005l-.08.07A.77.77 0 0112 11.17zM10.504 3a7.506 7.506 0 016.763 4.227l.105.23.108.003c3.544.121 6.395 2.949 6.517 6.469l.004.236c0 3.218-2.189 5.566-5.015 5.682l-.219.004h-2.68a.766.766 0 01-.105-1.525l.104-.007h2.681c2.073 0 3.702-1.688 3.702-4.154 0-2.86-2.337-5.177-5.226-5.177-.094 0-.192.006-.294.017a.766.766 0 01-.809-.506 5.969 5.969 0 00-5.636-3.967c-3.301 0-5.975 2.651-5.975 5.92 0 .278.024.556.072.848a.766.766 0 01-.517.851 3.69 3.69 0 00-2.551 3.5c0 1.661 1.22 2.6 3.107 2.665l.212.003h3.064a.766.766 0 01.104 1.525l-.104.007H4.85c-2.764 0-4.851-1.503-4.851-4.2a5.215 5.215 0 012.965-4.698l.051-.024-.01-.114-.01-.364C2.996 6.334 6.358 3 10.503 3z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgCloudUpload;
exports.default = _default;